import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    MenuItem,
    Select,
    TextField,
    FormHelperText,
    FormControl,
    InputLabel,
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useUserSubscriptionRequest } from 'components/TrialBanner/queries/useSubscription';
import { useNotification } from 'context/NotificationContext';
import styles from "./styles.module.scss"

const validationSchema = Yup.object({
    duration: Yup.number().required(),
    reason: Yup.string().trim().required('Reason is required'),
});

const RequestMoreTimeModal = ({ open, onClose }) => {
    const showNotification = useNotification()

    const onSuccess = () => {
        showNotification("Thanks! We’ll email you shortly with your new trial end date.", "success", "", null);
        onClose();
    }

    const onError = () => {
        showNotification("Error! Something went wrong, please try again later.", "error", "", null);
        onClose();
    }

    const mutation = useUserSubscriptionRequest({ onSuccess, onError });

    const isLoading = mutation.isLoading;

    const handleSubmit = async (values) => {
        await mutation.mutateAsync({ subscription_type: 'Trial', ...values });
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
                    <DialogTitle>
                        Need a little more time to test?
                        <br />
                        No problem, extend your trial.
                    </DialogTitle>

                    <Formik
                        initialValues={{ duration: 7, reason: '' }}
                        validationSchema={validationSchema}
                        onSubmit={(values) => handleSubmit(values)}
                    >
                        {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
                            <Form>
                                <DialogContent>
                                    <FormControl
                                        fullWidth
                                        margin="dense"
                                        error={touched.duration && Boolean(errors.duration)}
                                    >
                                        <InputLabel id="extraDays-label">Extra Days</InputLabel>
                                        <Select
                                            labelId="extraDays-label"
                                            name="duration"
                                            value={values.duration}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            label="Extra Days"
                                        >
                                            {[3, 7, 14, 30].map((days) => (
                                                <MenuItem key={days} value={days}>
                                                    {days} days
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.duration && errors.duration && (
                                            <FormHelperText>{errors.duration}</FormHelperText>
                                        )}
                                    </FormControl>

                                    <TextField
                                        sx={{mt: 2}}
                                        fullWidth
                                        multiline
                                        required
                                        rows={4}
                                        label="Reason"
                                        name="reason"
                                        margin="dense"
                                        value={values.reason}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.reason && Boolean(errors.reason)}
                                        helperText={touched.reason && errors.reason}
                                    />
                                </DialogContent>

                                <DialogActions sx={{px: 3, py: 2}}>
                                <Button className={styles.button} disabled={isSubmitting || isLoading} type="submit" variant="contained">
                                    {(isSubmitting || isLoading) ? 'Submitting...' : 'Request More Time'}
                                    </Button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
        </Dialog>
    );
};

export default RequestMoreTimeModal;
